import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';


import errorslist from '@/errors';

const errors = {
	state: {
		errorCode: '',
		errorMensaje: '',
		errorCustom : ''
	},
	getters: {
		getErrorCode: state => state.errorCode,
		getErrorMensaje: state => state.errorMensaje,
		getErrorCustom: state => state.errorCustom,
	},
	actions: {
		eraseError: ({ commit }) => {
			commit('setEraseError');
		},
		eraseErrorAndData: ({ commit, dispatch }) => {
			commit('setEraseError');
			console.log("FROM eraseErrorAndData");
			dispatch('logout');
		},
		setError: ({ commit }, error) => {
			commit('setError', error);
		},
		sendInfoAboutError: ({ commit, getters }, id) => {


			if (location.hostname != 'localhost') {

				var time = new Date()

				let data;
				data = '----------------------------------------\n';
				data += 'ERROR EN EL FRONT\n';
				data += 'URL del error:\n' + location.href + '\n';
				data += 'Código de error:\n' + id + '\n';
				data += 'Nombre del usuario:\n' + getters.getUserName + '\n';
				data += 'Versión:\n' + getters.getVersion + '\n';
				data += 'Hora del error:\n' + time.toTimeString() + '\n';
				data += 'Mensaje de error:\n';
				data += (!!errorslist[id]) ? errorslist[id].es.cuerpo + '\n' : 'Error Desconocido\n';
				data += '----------------------------------------';

				data = { "text": data };

				let url = 'https://hooks.slack.com/services/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';

				var xhr = new XMLHttpRequest();

				xhr.open("POST", url, true);

				xhr.send(JSON.stringify(data));

			}

		},

		sendCompleteInfo: ({ commit, getters }, error) => {



			if (location.hostname != 'localhost') {

				var time = new Date()

				let data;
				data = '----------------------------------------\n';
				data += 'ERROR EN SERVICIO\n';
				data += 'URL de la vista:\n' + location.href + '\n';
				data += 'Código de error:\n' + error.data.status + '\n';
				data += 'URL de llamada:\n' + error.request.responseURL + '\n';
				data += 'Nombre del usuario:\n' + getters.getUserName + '\n';
				data += 'Versión:\n' + getters.getVersion + '\n';
				data += 'Hora del error:\n' + time.toTimeString() + '\n';
				data += 'Mensaje de error:\n';
				data += (!!errorslist[error.data.status]) ? errorslist[error.data.status].es.cuerpo + '\n' : 'Error Desconocido\n';
				data += '----------------------------------------';

				data = { "text": data };

				let url = 'https://hooks.slack.com/services/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';

				var xhr = new XMLHttpRequest();

				xhr.open("POST", url, true);

				xhr.send(JSON.stringify(data));

			}

		},

		sendErrorServer: ({getters }, error) => {

			if (location.hostname != 'localhost' && !!error) {

				var time = new Date()

				let data;
				data = '----------------------------------------\n';
				data += 'ERROR EN EL SERVICIO\n';
				data += 'Hora del error:\n' + time.toTimeString() + '\n';
				data += 'Mensaje:\n' + error.data.Message + '\n';
				data += 'Versión:\n' + getters.getVersion + '\n';
				data += 'Detalle:\n' + error.data.MessageDetail + '\n';
				data += 'NAVEGADOR:' + window.navigator.userAgent + '\n';
				data += '----------------------------------------';

				data = { "text": data };

				let url = 'https://hooks.slack.com/services/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';

				var xhr = new XMLHttpRequest();
				xhr.open("POST", url, true);
				xhr.send(JSON.stringify(data));
			}
		},
		sendDataRegistroTRAZA: ({ getters }, dataOferta) => {

			if (location.hostname != 'localhost') {

				var time = new Date();

				let data;
				data = '----------------------------------------\n';
				data += 'DATOS REGISTRO\n';
				data += 'URL:\n' + location.href + '\n';
				data += 'Hora:\n' + time.toTimeString() + '\n';
				data += 'Versión:\n' + getters.getVersion + '\n';
				data += 'USUARIO: ' + getters.getUserName + '\n';
				data += 'NAVEGADOR:' + window.navigator.userAgent + '\n';
				// data += 'Mensaje:\n'+error.data.Message+'\n';

				Object.entries(dataOferta).forEach(el => {
					data += el[0] + ': ' + el[1] + '\n';
				});

				data += '----------------------------------------';

				data = { "text": data };

				let url = 'https://hooks.slack.com/services/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';

				var xhr = new XMLHttpRequest();
				xhr.open("POST", url, true);
				xhr.send(JSON.stringify(data));
			}
		},

		sendErrorTitulacionTRAZA: ({ getters }) => {


			// if(location.hostname != 'localhost'){

			var time = new Date();

			let data;
			data = '----------------------------------------\n';
			data += 'ERROR TITULACIÓN\n';
			data += 'Hora: ' + time.toTimeString() + '\n';
			data += 'URL:' + location.href + '\n';
			data += 'Versión:\n' + getters.getVersion + '\n';
			data += 'NAVEGADOR:' + window.navigator.userAgent + '\n';
			data += 'USUARIO: ' + getters.getUserName + '\n';
			data += '----------------------------------------\n';

			data = { "text": data };

			let url = 'https://hooks.slack.com/services/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';

			var xhr = new XMLHttpRequest();
			xhr.open("POST", url, true);
			xhr.send(JSON.stringify(data));
			// }
		},

		sendInfoPeticion: ({ getters }, info) => {


			if(location.hostname != 'localhost'){

			

			var time = new Date();

			let data;
			data = '----------------------------------------\n';
			data += 'Info Petición\n';
			data += 'Hora: ' + time.toTimeString() + '\n';
			data += 'URL:' + location.href + '\n';
			data += 'Versión:\n' + getters.getVersion + '\n';
			data += 'NAVEGADOR:' + window.navigator.userAgent + '\n';
			data += 'USUARIO: ' + getters.getUserName + '\n';
			data += 'info: ' + JSON.stringify(info) + '\n';
			data += '----------------------------------------\n';

			data = { "text": data };

			let url = 'https://hooks.slack.com/services/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';

			var xhr = new XMLHttpRequest();
			xhr.open("POST", url, true);
			xhr.send(JSON.stringify(data));
			}
		},


	},
	mutations: {
		setEraseError: function (state) {
			state.errorCode = '';
			state.errorMensaje = '';
			state.errorCustom = '';
		},
		setError: function (state, error) {
			state.errorCode = error;
			state.errorMensaje = null;
			state.errorCustom = '';
		},
		setCompleteError: function (state, error) {
			
			state.errorCode = error.data.status;
			state.errorMensaje = null;
			state.errorCustom = '';

			let errorsToWatch = ['1', '12', '24', '500'];
			if(errorsToWatch.some(e => e == error.data.status)){
				this.dispatch("sendCompleteInfo", error);
			}

		},
		setErrorMensaje: function (state, error) {

			state.errorCode = error.status;
			state.errorMensaje = error.mensaje;
			state.errorCustom = '';
		},
		setErrorCustomMensaje(state,mensaje){
			state.errorCode = 'custom';
			state.errorCustom = mensaje;
			state.errorMensaje = null;
		},
		setErrorRequisitos(state,response){	

			console.log(response)

			let mensaje = {
				es : {
					titulo : "Atención",
					mensaje : `Tu candidatura no es posible porque no cumple con los siguientes requisitos de la oferta: <strong>${response.response}</strong>.Por favor revisa tu perfil guardado para corregirlo o ponte en contacto con nosotros <a href="mailto:${response.getters.getBrand.emailInscripcion}">aquí</a> indicando tu DNI y la referencia de la oferta a la que te quieres inscribir.`
				},
				ca : {
					titulo : "Atenció",
					mensaje : `La teva candidatura no és possible perquè no compleix els següents requisits de l'oferta:<strong>${response.response}</strong>. Si us plau revisa el teu perfil guardat per corregir-ho o posa't en contacte amb nosaltres <a href="mailto:${response.getters.getBrand.emailInscripcion}">aquí</a> indicant el teu DNI i la referència de l'oferta a la que et vols inscriure.`
				}
			}

			

			state.errorCode = 'custom';
			state.errorMensaje = null;
			state.errorCustom = mensaje[response.lang];
		}

	}
}



export default errors;



// WEBPACK FOOTER //
// ./src/store/errors.js